/**
 * Estados y enumeraciones del dominio.
 *
 * 🔴 FUENTE DE VERDAD: `docs/01-analisis-y-especificacion-funcional.md` §4.1, §4.2 y §4.3,
 * y `docs/05-consentimiento-y-retencion-de-tracks.md` §4.2 y §5.
 * Este archivo NO inventa vocabulario ni "mejora" el de los documentos. Si algo falta,
 * se agrega a `docs/` y despues aca — nunca al reves. Los dos agregados que hoy no estan
 * en `docs/` van marcados abajo con `AGREGADO — documentar en docs/`.
 *
 * Es la razon de ser del monorepo: estos literales los consumen la API, la consola
 * y las dos apps moviles. Si divergen, el bug aparece en la calle y no en el CI.
 *
 * Convencion: uniones de literales de string, NO `enum` de TypeScript.
 *  - `enum` genera codigo en runtime y no sobrevive un `import type` ni el borrado
 *    de tipos de Babel/Metro, que es como compilan las apps Expo.
 *  - La union es puro tipo; la constante `*_TODOS` de al lado da la lista en runtime
 *    (validacion, seed, selects de la consola), y el `satisfies` garantiza que ambas
 *    no puedan separarse sin romper el build.
 */
export const ESTADOS_VIAJE_TODOS = [
    'SOLICITADO',
    'BUSCANDO',
    'ASIGNADO',
    'EN_ORIGEN',
    'EN_CURSO',
    'FINALIZADO',
    'CALIFICADO',
    'CANCELADO',
    'SIN_CONDUCTOR',
];
/**
 * Estados desde los que un viaje ya no transiciona.
 * ⚠️ `FINALIZADO` **no** es terminal: todavia puede pasar a `CALIFICADO`.
 */
export const ESTADOS_VIAJE_TERMINALES = [
    'CALIFICADO',
    'CANCELADO',
    'SIN_CONDUCTOR',
];
export const CANCELADO_POR_TODOS = [
    'PASAJERO',
    'CONDUCTOR',
    'SISTEMA',
    'OPERADOR',
];
export const RESULTADOS_OFERTA_TODOS = [
    'PENDIENTE',
    'GANADA',
    'PERDIDA',
    'RECHAZADA',
    'EXPIRADA',
];
/** Resultados FINALES tal como los lista `docs/01` §4.1. Excluye la oferta en vuelo. */
export const RESULTADOS_OFERTA_FINALES = [
    'GANADA',
    'PERDIDA',
    'RECHAZADA',
    'EXPIRADA',
];
export const ESTADOS_SUSCRIPCION_TODOS = [
    'SIN_INICIAR',
    'PENDIENTE',
    'ACTIVA',
    'FALLIDA',
    'VENCIDA',
    'CANCELADA',
];
/**
 * El unico estado que habilita el dispatch (R-01). Se expone como constante para que el
 * enforcement se escriba UNA vez y sea grepeable, en vez de repetir el literal `'ACTIVA'`
 * en cada punto donde se filtra el pool.
 */
export const ESTADO_SUSCRIPCION_HABILITA_DISPATCH = 'ACTIVA';
export const TIPOS_VEHICULO_TODOS = ['AUTO'];
/**
 * Las del conductor, en el orden en que sus rutas las devuelven. Las dos operativas de siempre van
 * PRIMERO y en su orden de siempre: quien indexa por posicion no se entera de que hay mas.
 */
export const FINALIDADES_CONSENTIMIENTO_CONDUCTOR = [
    'OPERACION_VIAJE',
    'TRAFICO_AGREGADO',
    'TERMINOS_CONDUCTOR',
    'POLITICA_CONDUCTOR',
];
/** Los consentimientos OPERATIVOS del conductor: aparte, uno por uno, y revocables. */
export const FINALIDADES_CONDUCTOR_OPERATIVAS = [
    'OPERACION_VIAJE',
    'TRAFICO_AGREGADO',
];
/** Terminos y Politica del conductor: obligatorias al alta, no revocables por separado. */
export const FINALIDADES_CONDUCTOR_ACEPTACION = [
    'TERMINOS_CONDUCTOR',
    'POLITICA_CONDUCTOR',
];
/** Las que el conductor puede revocar por separado (las operativas; Terminos/Politica NO). */
export const FINALIDADES_CONDUCTOR_REVOCABLES = [
    'OPERACION_VIAJE',
    'TRAFICO_AGREGADO',
];
/** Las del pasajero, en el orden en que sus rutas las devuelven. */
export const FINALIDADES_CONSENTIMIENTO_PASAJERO = [
    'TERMINOS_PASAJERO',
    'POLITICA_PASAJERO',
    'TRAFICO_AGREGADO_PASAJERO',
];
/** Las que el pasajero tiene que haber aceptado (a la version vigente) para pedir un viaje. */
export const FINALIDADES_PASAJERO_OBLIGATORIAS = [
    'TERMINOS_PASAJERO',
    'POLITICA_PASAJERO',
];
/** La unica que el pasajero puede revocar por separado. */
export const FINALIDADES_PASAJERO_REVOCABLES = [
    'TRAFICO_AGREGADO_PASAJERO',
];
/**
 * Terminos y Politica de AMBOS roles: ninguna se revoca por separado (retirarlas es la baja de
 * cuenta). Es la segunda cerradura de `ConsentimientoService.revocar`, por si una ruta la deja pasar.
 */
export const FINALIDADES_NO_REVOCABLES = [
    ...FINALIDADES_PASAJERO_OBLIGATORIAS,
    ...FINALIDADES_CONDUCTOR_ACEPTACION,
];
export const FINALIDADES_CONSENTIMIENTO_TODAS = [
    ...FINALIDADES_CONSENTIMIENTO_CONDUCTOR,
    ...FINALIDADES_CONSENTIMIENTO_PASAJERO,
];
export const METODOS_CONSENTIMIENTO_TODOS = [
    'APP_ALTA',
    'APP_AJUSTES',
    'CONSOLA',
];
//# sourceMappingURL=dominio.js.map